import { SET_SETTINGS } from "./actionTypes";

export const setSettings = (payload) => {
  return {
    type: SET_SETTINGS,
    payload,
  };
};
